const router = [

  //电子账户开通银行卡
  {
    path: '/ele/account/bank',
    name: 'EleAccountBank',
    component: () => import('@/views/ele-account/EleAccountBank.vue'),
    meta: {
      title: '电子账户开通',
      checkToken: false
    }
  },
    //电子账户合同
  {
    path: '/ele/account/contract',
    name: 'EleAccountContract',
    component: () => import('@/views/ele-account/EleAccountContract.vue'),
    meta: {
      title: '签署协议',
      checkToken: false
    }
  },
    //电子账户签署
  {
    path: '/ele/account/sign',
    name: 'EleAccountSign',
    component: () => import('@/views/ele-account/EleAccountSign.vue'),
    meta: {
      title: '签署协议',
      checkToken: false
    }
  },
    //电子账户签署
  {
    path: '/ele/account/submit',
    name: 'EleAccountSubmit',
    component: () => import('@/views/ele-account/EleAccountSubmit.vue'),
    meta: {
      title: '签署协议',
      checkToken: false
    }
  },
  
];
export default router;
